export default __webpack_public_path__ + "static/media/project-his.87337fbd.png";